import { pick } from "lodash";
import {
  LOT,
  LOT_LINE_ITEM,
  MANAGED_REPAIR_ORDER
} from "MODULES/Lots/constants";
import { TAG_COPIES, TRACEABILITY } from "MODULES/inventories/constants";
import { SERVICEABLE_TOOLING } from "MODULES/IncomingQuotes/constants";

export const PO = "po";
export const RO = "ro";
export const RMA = "rma";
export const SO = "so";
export const TRANSFER = "transfer";
export const MISTAKE_SHIPMENT = "mistake_shipment";
export const SHIPMENT = "shipment";
export const CORE_RETURN = "core_return";
export const CONSIGNMENT = "consignment";
export const CONSIGNMENT_BUYER = "consignment_buyer";
export const CONSIGNMENT_BUYER_ID = "consignment_buyer_id";
export const CONSIGNMENT_CO_BUYER = "consignment_co_buyer";
export const CONSIGNMENT_CO_BUYER_ID = "consignment_co_buyer_id";
export const CONSIGNMENT_LINE_ITEM = "consignment_line_item";
export const CONSIGNMENT_REFERENCE = "consignment_reference";
export const CONSIGNMENT_REFERENCE_COMPANY = "consignment_reference_company";
export const CONSIGNMENT_REFERENCE_COMPANY_TYPE =
  "consignment_reference_company";
export const CONSIGNMENT_REFERENCE_COMPANY_ID =
  "consignment_reference_company_id";
export const CONSIGNOR_PERCENTAGE = "consignor_percentage";
export const DISCREPANCY_TYPE = "discrepancy_type";
export const EMA = "ema";
export const EXPORT_HOLD = "export_hold";
export const NEW_COMPANY_HOLD = "new_company_hold";
export const REASON_FOR_RESOLUTION = "reason_for_resolution";
export const VIRTUALLY_RECEIVING = "virtually_receiving";

export const RECEIVING_TYPES = {
  [EMA]: {
    label: "EMA",
    link: "purchase-orders"
  },
  [LOT]: {
    label: "Lot",
    link: "lots"
  },
  [LOT_LINE_ITEM]: {
    label: "Lot",
    link: "lots"
  },
  [MANAGED_REPAIR_ORDER]: {
    label: "MR",
    link: "managed-repair-orders"
  },
  [PO]: {
    label: "PO",
    link: "purchase-orders"
  },
  [RO]: {
    label: "RO",
    link: "repair-orders"
  },
  [SO]: {
    label: "SO",
    link: "sales-orders"
  },
  [RMA]: {
    label: "RMA",
    link: "rmas"
  },
  [MISTAKE_SHIPMENT]: {
    label: "Mistake Shipment",
    link: "mistake-shipments"
  },
  [CORE_RETURN]: {
    label: "Core Return"
  },
  [CONSIGNMENT]: {
    label: "Consignment",
    link: "purchase-orders"
  },
  [TRANSFER]: {
    label: "TR"
  }
};

export const REASON_FOR_RESOLUTION_OPTIONS = [
  "Requested Paperwork",
  "Requested Revised Paperwork",
  "Requested Warranty / RMA",
  "Non - Discrepancy",
  "Other"
];

export const SETTABLE_RECEIVING_TYPES = pick(
  RECEIVING_TYPES,
  MISTAKE_SHIPMENT,
  CONSIGNMENT,
  EMA,
  LOT_LINE_ITEM
);

export const AS_REMOVED = "as_removed";
export const BEYOND_ECON_REPAIR = "beyond_econ_repair";
export const INSPECTED = "inspected";
export const NEW = "new_item";
export const OVERHAULED = "overhauled";
export const PARTS_UNIT = "parts_unit";
export const RECEIVING_TYPE = "receiving_type";
export const RECEIVED_VIRTUALLY = "received_virtually";
export const REPAIRED = "repaired";

export const SCRAP = "scrap";

export const CONDITION_TYPES = {
  [AS_REMOVED]: {
    label: "As Removed",
    abbrev: "AR"
  },
  [BEYOND_ECON_REPAIR]: {
    label: "Beyond Econ. Repair",
    abbrev: "BR"
  },
  [INSPECTED]: {
    label: "Inspected",
    abbrev: "BT"
  },
  [NEW]: {
    label: "New",
    abbrev: "NE"
  },
  [OVERHAULED]: {
    label: "Overhauled",
    abbrev: "OH"
  },
  [PARTS_UNIT]: {
    label: "Parts Unit",
    abbrev: "PU"
  },
  [REPAIRED]: {
    label: "Repaired",
    abbrev: "SV"
  },
  [SCRAP]: {
    label: "Scrap",
    abbrev: "SC"
  },
  [SERVICEABLE_TOOLING]: {
    label: "Serviceable Tooling",
    abbrev: "SV"
  }
};

export const TAG_DATE_CONDITIONS = [OVERHAULED, REPAIRED, INSPECTED];

export const PASS = "pass";
export const QC_HOLD = "qc_hold";
export const UNDER_REVIEW = "under_review";

export const QC_STATUS_TYPES = {
  [PASS]: {
    label: "Pass"
  },
  [QC_HOLD]: {
    label: "QC Hold"
  }
};

export const EXPIRING_SOON = "expiring_soon";
export const SHIPPING_DAMAGE_TO_PACKAGE = "shipping_damage_to_the_package";
export const SHIPPING_DAMAGE_TO_PART = "shipping_damage_to_the_part";
export const UNIT_PACKAGED_INCORRECTLY = "unit_packaged_incorrectly";
export const DAMAGE_TO_PART = "damage_to_the_part";

export const DISCREPANCY = "discrepancy";
export const PART_NUMBER_DISCREPANCY = "part_number_discrepancy";
export const SERIAL_NUMBER_DISCREPANCY = "serial_number_discrepancy";
export const CONDITION_DISCREPANCY = "condition_discrepancy";
export const TAGGED_BY_DISCREPANCY = "tagged_by_discrepancy";
export const RECEIVING_STORE_INCORRECT = "receiving_store_incorrect";
export const MISSING_SAFETY_WIRE = "missing_safety_wire";
export const ASSEMBLED_LOOSELY = "assembled_loosely";
export const DISASSEMBLED = "disassembled";
export const MISSING_PARTS = "missing_parts";
export const MISSING_DATA_PLATE = "missing_data_plate";
export const MISSING_SIGNATURE_OR_NAME = "missing_signature_or_name";
export const MISSING_WORK_ORDER = "missing_work_order";
export const NO_DUAL_RELEASE = "no_dual_release";
export const MISSING_PAPERWORK = "missing_paperwork";
export const COVERS_CAPS_PLUGS_FILTERS_MISSING =
  "covers_caps_plugs_and_or_fittings_missing";
export const OTHER = "other";
export const EXTRA_PARTS_ATTACHED = "extra_parts_attached";

export const DISCREPANCY_TYPES = {
  [ASSEMBLED_LOOSELY]: {
    label: "Assembled loosely"
  },
  [CONDITION_DISCREPANCY]: {
    label: "Condition discrepancy"
  },
  [COVERS_CAPS_PLUGS_FILTERS_MISSING]: {
    label: "Covers, caps, plugs or filters missing"
  },
  [DAMAGE_TO_PART]: {
    label: "Damage to the part"
  },
  [DISASSEMBLED]: {
    label: "Disassembled"
  },
  [EXPIRING_SOON]: {
    label: "Expired/Soon to expire"
  },
  [EXTRA_PARTS_ATTACHED]: {
    label: "Extra part/s attached"
  },
  [MISSING_DATA_PLATE]: {
    label: "Missing data plate"
  },
  [MISSING_PAPERWORK]: {
    label: "Missing paperwork"
  },
  [MISSING_PARTS]: {
    label: "Missing parts"
  },
  [MISSING_SAFETY_WIRE]: {
    label: "Missing safety wire"
  },
  [MISSING_SIGNATURE_OR_NAME]: {
    label: "Missing signature or name"
  },
  [MISSING_WORK_ORDER]: {
    label: "Missing work order"
  },
  [NO_DUAL_RELEASE]: {
    label: "No dual release"
  },
  [PART_NUMBER_DISCREPANCY]: {
    label: "Part number discrepancy"
  },
  [RECEIVING_STORE_INCORRECT]: {
    label: "Receiving Store Location Incorrect"
  },
  [SERIAL_NUMBER_DISCREPANCY]: {
    label: "Serial number discrepancy"
  },
  [SHIPPING_DAMAGE_TO_PACKAGE]: {
    label: "Shipping damage to the package"
  },
  [SHIPPING_DAMAGE_TO_PART]: {
    label: "Shipping damage to the part"
  },
  [TAGGED_BY_DISCREPANCY]: {
    label: "Tagged By Discrepancy"
  },
  [UNIT_PACKAGED_INCORRECTLY]: {
    label: "Unit packaged incorrectly"
  },
  [OTHER]: {
    label: "Other"
  }
};

export const DATA_PLATE_DOM_PHOTOS = "data_plate_dom_photos";
export const PHOTOS_RECEIVING_INSPECTION = "photos_receiving_inspection";
export const PHOTOS_RECEIVING_PACKAGING_INSPECTION =
  "photos_receiving_packaging_inspection";

export const ATTACHMENT_TYPES = {
  [DATA_PLATE_DOM_PHOTOS]: {
    label: "Data Plate / DOM Photos"
  },
  [PHOTOS_RECEIVING_INSPECTION]: {
    label: "Photos - Receiving Inspection"
  },
  [PHOTOS_RECEIVING_PACKAGING_INSPECTION]: {
    label: "Photos - Receiving Packaging Inspection"
  },
  [TAG_COPIES]: {
    label: "Tag Copies"
  },
  [TRACEABILITY]: {
    label: "Traceability"
  }
};

export const RECORD_TYPES = {
  purchase_order_line_item: {
    label: "PO"
  },
  rma: {
    label: "RMA"
  },
  sales_order_line_item: {
    label: "SO"
  },
  managed_repair_order_line_item: {
    label: "MRO"
  },
  repair_order_line_item: {
    label: "RO"
  },
  inventory_transfer_order: {
    label: "TR"
  }
};

export const ACTION_CONDITIONS = {
  repair: "repaired",
  overhaul: "overhauled",
  bench_test: "inspected",
  tear_down: "parts_unit"
};

export const RECEIVING_CHECKLIST_QUESTIONS = {
  shipped_properly:
    "Shipped properly, packaged under ATA-300 Spec. guidelines and there is no visible damage to the package",
  vendor_packing_list_included:
    "Unit/s accompanied with vendor’s packing list referencing accurate part number, serial number, quantity, and condition",
  packing_list_and_tags_match:
    "Unit/s packing list and tag documents (if applicable) match data plate",
  passed_damage_inspection:
    "Unit/s inspected to be free of corrosion, pitting, contamination, leakage, and/or missing parts and there is no visible damage",
  release_certificate_included:
    "Serviceable item/s have authorized release certificates and all plugs & fittings, and openings are covered to prevent leakage or contamination"
};



// WEBPACK FOOTER //
// ./app/modules/Receiving/constants.js